import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_SYNTHETIC_WELL_LOGS_PAGE = graphql(`
  query StudySyntheticWellLogsPage($id: ID!) {
    studyGet(id: $id) {
      id
      syntheticWellLogs {
        ...syntheticWellLogParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }
    }
  }
`);

export default function StudySyntheticWellLogsPage() {
  return (
    <ApolloProviderV4>
      <StudySyntheticWellLogsPageInner />
    </ApolloProviderV4>
  );
}

function StudySyntheticWellLogsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_SYNTHETIC_WELL_LOGS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_SYNTHETIC_WELL_LOGS_PAGE, variables: { id: studyId } },
  ]);

  const wellLogs = data?.studyGet?.syntheticWellLogs ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={wellLogs}
      soParentType="study"
      soParentId={studyId}
      // bookmarkParentType={BookmarkParentType.SyntheticWellLog}
      refetchQueries={refetchQueries}
    />
  );
}
